import { render, staticRenderFns } from "./MonthWrap.vue?vue&type=template&id=0226358a&scoped=true"
import script from "./MonthWrap.vue?vue&type=script&lang=js"
export * from "./MonthWrap.vue?vue&type=script&lang=js"
import style0 from "./MonthWrap.vue?vue&type=style&index=0&id=0226358a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0226358a",
  null
  
)

export default component.exports